import { Box } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { ChevronDown } from '@sweep-io/sweep-design/dist/icons/ChevronDown';
import { ChevronUp } from '@sweep-io/sweep-design/dist/icons/ChevronUp';
import { DASHBOARD_BUTTON_HOVER_COLOR } from '../../../dashboard/dashboardHelper';

interface MenuButtonProps {
  pressed?: boolean;
  disabled?: boolean;
  anchorRef?: any;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  children: React.ReactNode;
}

export const MenuButton = ({
  anchorRef,
  pressed,
  onClick,
  disabled,
  children,
}: MenuButtonProps) => {
  return (
    <Box
      ref={anchorRef}
      onClick={disabled ? undefined : onClick}
      className={pressed ? 'menu-button-pressed' : ''}
      sx={{
        cursor: disabled ? 'default' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        height: '32px',
        gap: 2,
        '&:hover, &.menu-button-pressed': {
          background: disabled ? undefined : DASHBOARD_BUTTON_HOVER_COLOR,
        },
        padding: '8px 16px',
        borderRadius: '4px',
        border: `1px solid ${colors.grey[300]}`,
        minWidth: 0,
      }}
    >
      {children}
      {pressed ? (
        <ChevronUp size="medium" color={colors.grey[900]} />
      ) : (
        <ChevronDown size="medium" color={colors.grey[900]} />
      )}
    </Box>
  );
};
